import {
  FILTER_TYPE_TEXT,
  FILTER_TYPE_MULTISELECT,
  FILTER_TYPE_DATETIME,
  FILTER_TYPE_INTEGER,
  FILTER_TYPE_SELECT
} from "@/store/system/helpers";

export function getBlankCriteria() {
  return {
    id: null,
    levels: [],
    server: null,
    userName: null,
    fromDate: null,
    toDate: null,
    search: null
  };
}

export function getSearchFilters() {
  return [
    { text: "Message", value: "search", type: FILTER_TYPE_TEXT },
    {
      text: "Level",
      value: "levels",
      default: true,
      type: FILTER_TYPE_MULTISELECT,
      items: [
        { text: "Trace", value: "Trace" },
        { text: "Debug", value: "Debug" },
        { text: "Info", value: "Info" },
        { text: "Warn", value: "Warn" },
        { text: "Error", value: "Error" },
        { text: "Fatal", value: "Fatal" }
      ]
    },
    { text: "Request path", value: "requestPath", type: FILTER_TYPE_TEXT },
    {
      text: "Request method",
      value: "requestMethod",
      type: FILTER_TYPE_SELECT,
      items: [
        { text: "GET", value: "GET" },
        { text: "PUT", value: "PUT" },
        { text: "POST", value: "POST" },
        { text: "DELETE", value: "DELETE" }
      ]
    },
    { text: "ID", value: "id", type: FILTER_TYPE_INTEGER },
    { text: "Server", value: "server", type: FILTER_TYPE_TEXT },
    { text: "User", value: "userName", type: FILTER_TYPE_TEXT },
    { text: "From", value: "fromDate", type: FILTER_TYPE_DATETIME },
    { text: "To", value: "toDate", type: FILTER_TYPE_DATETIME }
  ];
}

export function getBlankRecord() {
  return {
    id: null,
    server: null,
    date: null,
    level: null,
    userId: null,
    userName: null,
    message: null,
    logger: null,
    callsite: null,
    exception: null,
    requestPath: null,
    requestMethod: null,
    requestContentType: null
  };
}

var ExceptionChartColors = {
  Trace: "#3182bd",
  Debug: "#636363",
  Info: "#31a354",
  Warn: "#fd8d3c",
  Error: "#f44336",
  Fatal: "#ff0000"
};

export { ExceptionChartColors };
